import { useClient } from "creso-core/hooks";
import { useRouter, useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import { Button, cn } from "web-design-system";
import { RefreshCcwIcon } from "lucide-react";
import { MandateList, useMandateActions } from "web-core";
import MandateLayout from "./mandate-layout";

export default function MandateListContainer() {
  const router = useRouter();
  const { client_id = 0 } = useSearch({ from: Route.id });
  const { data: clientData, isLoading: isLoadingClient } = useClient(client_id);

  const investmentAccountGuid = clientData?.investment_account ?? "";

  const {
    mandates,
    isLoading,
    isFetching,
    isNotifying,
    refresh,
    notify,
    download,
    remove,
  } = useMandateActions(investmentAccountGuid);

  return (
    <MandateLayout
      action={
        <Button
          size="lg"
          className="w-full"
          onClick={() => {
            router.navigate({
              to: ".",
              search: (prev: Record<string, unknown>) => {
                return { ...prev, context: "create-form" };
              },
              replace: true,
            });
          }}
        >
          Add new mandate
        </Button>
      }
      {...(clientData
        ? { title: `Mandates for ${clientData.name}` }
        : { title: "" })}
      secondaryAction={
        <Button
          size="icon"
          variant="outline"
          className="shrink-0"
          onClick={refresh}
        >
          <RefreshCcwIcon
            className={cn("size-4", isFetching && "animate-spin")}
          />
        </Button>
      }
    >
      <MandateList
        mandates={mandates}
        isLoading={isLoading || isLoadingClient}
        isNotifying={isNotifying}
        onNotify={notify}
        onDownload={download}
        onDelete={remove}
        onSelect={(mandate) =>
          router.navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              return {
                ...prev,
                context: "upload",
                mandate_id: mandate.id,
              };
            },
            replace: true,
          })
        }
      />
    </MandateLayout>
  );
}
